import Styles from './CodeInput.module.scss'
import ReactCodeInput from 'react-verification-code-input'

export const CodeInput = ({ disabled, clearInput, onChange, onComplete }: any) => {
  return (
    <div className={Styles.codeWrapper} key={clearInput}>
      <ReactCodeInput
        disabled={disabled}
        className={Styles.verificationCode}
        type="number"
        fields={4}
        fieldHeight={64}
        onComplete={onComplete}
        onChange={onChange}
        values={Array(4).fill('')}
        data-heap-id="email-verification-code"
      />
    </div>
  )
}
